/* eslint-disable max-lines */
import { createReducer, INITIAL_STATE } from '@shared/redux';
import { LOAD_STATE } from '@shared/axios/axios.constants';
import {
    changeTeamClassificationApiConfig,
    deleteInviteApiConfig,
    deleteUserApiConfig,
    getInvitesApiConfig,
    getTeamMembersApiConfig,
    getTeamClassificationApiConfig,
    roleChangeApiConfig,
    sendInviteApiConfig,
} from './team.screen.api';

const GET_TEAM_MEMBERS_REQUEST_CALLED = '@team/GET_TEAM_MEMBERS_REQUEST_CALLED';
const GET_TEAM_MEMBERS_REQUEST_SUCCEEDED = '@team/GET_TEAM_MEMBERS_REQUEST_SUCCEEDED';
export const GET_TEAM_MEMBERS_REQUEST_FAILED = '@team/GET_TEAM_MEMBERS_REQUEST_FAILED';

const GET_TEAM_INVITES_REQUEST_CALLED = '@team/GET_TEAM_INVITES_REQUEST_CALLED';
const GET_TEAM_INVITES_REQUEST_SUCCEEDED = '@team/GET_TEAM_INVITES_REQUEST_SUCCEEDED';
export const GET_TEAM_INVITES_REQUEST_FAILED = '@team/GET_TEAM_INVITES_REQUEST_FAILED';

const GET_TEAM_CLASSIFICATIONS_REQUEST_CALLED = '@team/GET_TEAM_CLASSIFICATIONS_REQUEST_CALLED';
const GET_TEAM_CLASSIFICATIONS_REQUEST_SUCCEEDED = '@team/GET_TEAM_CLASSIFICATIONS_REQUEST_SUCCEEDED';
const GET_TEAM_CLASSIFICATIONS_REQUEST_FAILED = '@team/GET_TEAM_CLASSIFICATIONS_REQUEST_FAILED';

const EDIT_MEMBER_ROLE_REQUEST_CALLED = '@team/EDIT_MEMBER_ROLE_REQUEST_CALLED';
export const EDIT_MEMBER_ROLE_REQUEST_SUCCEEDED = '@team/EDIT_MEMBER_ROLE_REQUEST_SUCCEEDED';
export const EDIT_MEMBER_ROLE_REQUEST_FAILED = '@team/EDIT_MEMBER_ROLE_REQUEST_FAILED';

const EDIT_TEAM_CLASSIFICATIONS_REQUEST_CALLED = '@team/EDIT_TEAM_CLASSIFICATIONS_REQUEST_CALLED';
const EDIT_TEAM_CLASSIFICATIONS_REQUEST_SUCCEEDED = '@team/EDIT_TEAM_CLASSIFICATIONS_REQUEST_SUCCEEDED';
const EDIT_TEAM_CLASSIFICATIONS_REQUEST_FAILED = '@team/EDIT_TEAM_CLASSIFICATIONS_REQUEST_FAILED';

const SEND_INVITE_REQUEST_CALLED = '@team/SEND_INVITE_REQUEST_CALLED';
export const SEND_INVITE_REQUEST_SUCCEEDED = '@team/SEND_INVITE_REQUEST_SUCCEEDED';
export const SEND_INVITE_REQUEST_FAILED = '@team/SEND_INVITE_REQUEST_FAILED';
export const INVITEE_EMAIL_VALIDATE = '@team/INVITEE_EMAIL_VALIDATE';
export const INVITEE_EMAIL_ERROR_UPDATE = '@team/INVITEE_EMAIL_ERROR_UPDATE';
const INVITEE_EMAIL_NOT_VALID = '@team/INVITEE_EMAIL_NOT_VALID';

const DELETE_INVITE_REQUEST_CALLED = '@team/DELETE_INVITE_REQUEST_CALLED';
export const DELETE_INVITE_REQUEST_SUCCEEDED = '@team/DELETE_INVITE_REQUEST_SUCCEEDED';
export const DELETE_INVITE_REQUEST_FAILED = '@team/DELETE_INVITE_REQUEST_FAILED';

const DELETE_USER_REQUEST_CALLED = '@team/DELETE_USER_REQUEST_CALLED';
export const DELETE_USER_REQUEST_SUCCEEDED = '@team/DELETE_USER_REQUEST_SUCCEEDED';
export const DELETE_USER_REQUEST_FAILED = '@team/DELETE_USER_REQUEST_FAILED';

const CLOSE_TEAM_INVITE_MODAL = '@team/CLOSE_TEAM_INVITE_MODAL';
const OPEN_TEAM_INVITE_MODAL = '@team/OPEN_TEAM_INVITE_MODAL';

export const OPEN_DELETE_MODAL_FAILED = '@team/OPEN_DELETE_MODAL_FAILED';
export const OPEN_INVITE_MODAL_FAILED = '@team/OPEN_INVITE_MODAL_FAILED';

const INVALID_ROLE_ERROR = '@team/INVALID_ROLE_ERROR';

const SET_INVITE_EMAIL = '@team/SET_INVITE_EMAIL';
const SET_INVITE_ROLE = '@team/SET_INVITE_ROLE';

export const teamMembers = state => state.teamScreen.team.members.data;
export const teamInvites = state => state.teamScreen.team.invitees.data;
export const getTeamMembersLoading = state => state.teamScreen.team.members.loadState;
export const getTeamInviteesLoading = state => state.teamScreen.team.invitees.loadState;
export const getModalLoading = state => state.teamScreen.modalLoadState;
export const getTeamClassificationTags = state => state.teamScreen.classificationsTags.data;
export const getTeamClassificationLoading = state => state.teamScreen.classificationsTags.loadState;
export const isInviteModalOpen = state => state.teamScreen.isInviteModalOpen;
export const getInvalidRoleError = state => state.teamScreen.team.invalidRoleError;
export const getValidationError = state => state.teamScreen.team.validationError;
export const getInviteEmail = state => state.teamScreen.modalInvite.inviteEmail;
export const getInviteRole = state => state.teamScreen.modalInvite.inviteRole;

export const getTeamMembers = () => ({
    type: GET_TEAM_MEMBERS_REQUEST_CALLED,
    actionTypes: {
        success: GET_TEAM_MEMBERS_REQUEST_SUCCEEDED,
        fail: GET_TEAM_MEMBERS_REQUEST_FAILED,
    },
    config: getTeamMembersApiConfig(),
});

export const getTeamInviteMembers = () => ({
    type: GET_TEAM_INVITES_REQUEST_CALLED,
    actionTypes: {
        success: GET_TEAM_INVITES_REQUEST_SUCCEEDED,
        fail: GET_TEAM_INVITES_REQUEST_FAILED,
    },
    config: getInvitesApiConfig(),
});

export const deleteInviteMember = itemId => ({
    type: DELETE_INVITE_REQUEST_CALLED,
    actionTypes: {
        success: DELETE_INVITE_REQUEST_SUCCEEDED,
        fail: DELETE_INVITE_REQUEST_FAILED,
    },
    payload: { itemId },
    config: deleteInviteApiConfig({ itemId }),
});

export const deletedMember = (userId, username) => ({
    type: DELETE_USER_REQUEST_CALLED,
    actionTypes: {
        success: DELETE_USER_REQUEST_SUCCEEDED,
        fail: DELETE_USER_REQUEST_FAILED,
    },
    payload: { userId, username },
    config: deleteUserApiConfig({ userId }),
});

export const changeMemberRole = (id, role) => ({
    type: EDIT_MEMBER_ROLE_REQUEST_CALLED,
    actionTypes: {
        success: EDIT_MEMBER_ROLE_REQUEST_SUCCEEDED,
        fail: EDIT_MEMBER_ROLE_REQUEST_FAILED,
    },
    config: roleChangeApiConfig({ id, role }),
});

export const sendInviteToUser = (inviteRole, inviteEmail) => ({
    type: SEND_INVITE_REQUEST_CALLED,
    actionTypes: {
        success: SEND_INVITE_REQUEST_SUCCEEDED,
        fail: SEND_INVITE_REQUEST_FAILED,
    },
    config: sendInviteApiConfig({ inviteRole, inviteEmail }),
});

export const getTeamClassification = () => ({
    type: GET_TEAM_CLASSIFICATIONS_REQUEST_CALLED,
    actionTypes: {
        success: GET_TEAM_CLASSIFICATIONS_REQUEST_SUCCEEDED,
        fail: GET_TEAM_CLASSIFICATIONS_REQUEST_FAILED,
    },
    config: getTeamClassificationApiConfig(),
});

export const changeTeamClassification = (id, value) => ({
    type: EDIT_TEAM_CLASSIFICATIONS_REQUEST_CALLED,
    actionTypes: {
        success: EDIT_TEAM_CLASSIFICATIONS_REQUEST_SUCCEEDED,
        fail: EDIT_TEAM_CLASSIFICATIONS_REQUEST_FAILED,
    },
    config: changeTeamClassificationApiConfig({ id, value }),
});

export const closeInviteModal = () => ({
    type: CLOSE_TEAM_INVITE_MODAL,
    payload: {},
});

export const openInviteModal = () => ({
    type: OPEN_TEAM_INVITE_MODAL,
    payload: {},
});

export const validateInviteeEmail = ({ email }) => ({
    type: INVITEE_EMAIL_VALIDATE,
    payload: { email },
});

export const inviteeEmailNotValid = ({ error }) => ({
    type: INVITEE_EMAIL_NOT_VALID,
    payload: { error },
});

export const updateInviteeEmailError = ({ error }) => ({
    type: INVITEE_EMAIL_ERROR_UPDATE,
    payload: { error },
});

export const openDeleteModalFailed = () => ({
    type: OPEN_DELETE_MODAL_FAILED,
    payload: {},
});

export const openInviteModalFailed = () => ({
    type: OPEN_INVITE_MODAL_FAILED,
    payload: {},
});

export const handleInvalidRoleError = message => ({
    type: INVALID_ROLE_ERROR,
    payload: { message },
});

export const setInviteEmail = value => ({
    type: SET_INVITE_EMAIL,
    payload: { value },
});

export const setInviteRole = value => ({
    type: SET_INVITE_ROLE,
    payload: { value },
});

const initialState = {
    isInviteModalOpen: false,
    modalLoadState: LOAD_STATE.SUCCESS,
    team: {
        members: {
            loadState: LOAD_STATE.LOADING,
            data: [],
            error: null,
        },
        invitees: {
            loadState: LOAD_STATE.LOADING,
            data: [],
            error: null,
        },
    },
    classificationsTags: {
        loadState: LOAD_STATE.LOADING,
        data: [],
        error: null,
    },
    modalInvite: {
        inviteEmail: '',
        inviteRole: '',
    },
};

export const teamMembersScreenReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_TEAM_MEMBERS_REQUEST_CALLED]: state => ({
        ...state,
        team: {
            ...state.team,
            members: {
                ...state.team.members,
                loadState: LOAD_STATE.LOADING,
            },
        },
    }),
    [GET_TEAM_MEMBERS_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        team: {
            ...state.team,
            members: {
                loadState: LOAD_STATE.SUCCESS,
                data: action.payload.data,
                error: null,
            },
        },
    }),
    [GET_TEAM_MEMBERS_REQUEST_FAILED]: (state, action) => ({
        ...state,
        team: {
            ...state.team,
            members: {
                ...state.team.members,
                loadState: LOAD_STATE.FAIL,
                error: action.payload,
            },
        },
    }),
    [GET_TEAM_INVITES_REQUEST_CALLED]: state => ({
        ...state,
        team: {
            ...state.team,
            invitees: {
                ...state.team.invitees,
                loadState: LOAD_STATE.LOADING,
            },
        },
    }),
    [GET_TEAM_INVITES_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        team: {
            ...state.team,
            invitees: {
                loadState: LOAD_STATE.SUCCESS,
                data: action.payload.data,
                error: null,
            },
        },
    }),
    [GET_TEAM_INVITES_REQUEST_FAILED]: (state, action) => ({
        ...state,
        team: {
            ...state.team,
            invitees: {
                ...state.team.invitees,
                loadState: LOAD_STATE.FAIL,
                error: action.payload,
            },
        },
    }),
    [DELETE_INVITE_REQUEST_CALLED]: state => ({
        ...state,
        modalLoadState: LOAD_STATE.LOADING,
        team: {
            ...state.team,
            invitees: {
                ...state.team.invitees,
                loadState: LOAD_STATE.LOADING,
            },
        },
    }),
    [DELETE_INVITE_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        modalLoadState: LOAD_STATE.SUCCESS,
        team: {
            ...state.team,
            invitees: {
                loadState: LOAD_STATE.SUCCESS,
                data: state.team.invitees.data
                    .filter(invite => invite.id !== action.requestAction.payload.itemId),
                error: null,
            },
        },
    }),
    [DELETE_INVITE_REQUEST_FAILED]: (state, action) => ({
        ...state,
        modalLoadState: LOAD_STATE.FAIL,
        team: {
            ...state.team,
            invitees: {
                ...state.team.invitees,
                loadState: LOAD_STATE.FAIL,
                error: action.payload,
            },
        },
    }),
    [EDIT_MEMBER_ROLE_REQUEST_CALLED]: state => ({
        ...state,
        team: {
            ...state.team,
            loadState: LOAD_STATE.LOADING,
        },
    }),
    [EDIT_MEMBER_ROLE_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        team: {
            ...state.team,
            members: {
                loadState: LOAD_STATE.SUCCESS,
                data: state.team.members.data.map((member) => {
                    if (member.membership_id === action.payload.data.membership_id) {
                        return {
                            ...member,
                            role: action.payload.data.role,
                        };
                    }
                    return member;
                }),
                error: null,
            },
        },
    }),
    [EDIT_MEMBER_ROLE_REQUEST_FAILED]: (state, action) => ({
        ...state,
        team: {
            ...state.team,
            members: {
                ...state.team.members,
                loadState: LOAD_STATE.FAIL,
                error: action.payload,
            },
        },
    }),
    [SEND_INVITE_REQUEST_CALLED]: state => ({
        ...state,
        modalLoadState: LOAD_STATE.LOADING,
        team: {
            ...state.team,
            invitees: {
                ...state.team.invitees,
                loadState: LOAD_STATE.LOADING,
            },
        },
    }),
    [SEND_INVITE_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        isInviteModalOpen: false,
        modalLoadState: LOAD_STATE.SUCCESS,
        team: {
            ...state.team,
            invitees: {
                loadState: LOAD_STATE.SUCCESS,
                data: [
                    ...state.team.invitees.data,
                    action.payload.data,
                ],
                error: null,
            },
        },
        modalInvite: {
            ...state.modalInvite,
            inviteEmail: '',
            inviteRole: '',
        },
    }),
    [SEND_INVITE_REQUEST_FAILED]: (state, action) => ({
        ...state,
        modalLoadState: LOAD_STATE.FAIL,
        team: {
            ...state.team,
            invitees: {
                ...state.team.invitees,
                loadState: LOAD_STATE.FAIL,
                error: action.payload,
            },
        },
    }),
    [DELETE_USER_REQUEST_CALLED]: state => ({
        ...state,
        modalLoadState: LOAD_STATE.LOADING,
        team: {
            ...state.team,
            members: {
                ...state.team.members,
                loadState: LOAD_STATE.LOADING,
            },
        },
    }),
    [DELETE_USER_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        modalLoadState: LOAD_STATE.SUCCESS,
        team: {
            ...state.team,
            members: {
                loadState: LOAD_STATE.SUCCESS,
                data: state.team.members.data
                    .filter(
                        member => member.membership_id !== action.requestAction.payload.userId,
                    ),
                error: null,
            },
        },
    }),
    [DELETE_USER_REQUEST_FAILED]: (state, action) => ({
        ...state,
        modalLoadState: LOAD_STATE.FAIL,
        team: {
            ...state.team,
            members: {
                ...state.team.members,
                loadState: LOAD_STATE.FAIL,
                error: action.payload,
            },
        },
    }),
    [GET_TEAM_CLASSIFICATIONS_REQUEST_CALLED]: state => ({
        ...state,
        classificationsTags: {
            ...state.classificationsTags,
            loadState: LOAD_STATE.LOADING,
        },
    }),
    [GET_TEAM_CLASSIFICATIONS_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        classificationsTags: {
            loadState: LOAD_STATE.SUCCESS,
            data: action.payload.data,
            error: null,
        },
    }),
    [GET_TEAM_CLASSIFICATIONS_REQUEST_FAILED]: (state, action) => ({
        ...state,
        classificationsTags: {
            ...state.classificationsTags,
            loadState: LOAD_STATE.FAIL,
            error: action.payload,
        },
    }),
    [OPEN_TEAM_INVITE_MODAL]: state => ({
        ...state,
        isInviteModalOpen: true,
        team: {
            ...state.team,
            invalidRoleError: null,
            validationError: null,
        },
    }),
    [CLOSE_TEAM_INVITE_MODAL]: state => ({
        ...state,
        isInviteModalOpen: false,
        modalInvite: {
            ...state.modalInvite,
            inviteEmail: '',
            inviteRole: '',
        },
    }),
    [INVITEE_EMAIL_ERROR_UPDATE]: (state, action) => ({
        ...state,
        team: {
            ...state.team,
            validationError: action.payload.error,
        },
    }),
    [INVITEE_EMAIL_NOT_VALID]: (state, action) => ({
        ...state,
        team: {
            ...state.team,
            validationError: action.payload.error,
        },
    }),
    [OPEN_DELETE_MODAL_FAILED]: state => ({
        ...state,
    }),
    [OPEN_INVITE_MODAL_FAILED]: state => ({
        ...state,
    }),
    [INVALID_ROLE_ERROR]: (state, action) => ({
        ...state,
        team: {
            ...state.team,
            invalidRoleError: action.payload,
        },
    }),
    [SET_INVITE_EMAIL]: (state, action) => ({
        ...state,
        modalInvite: {
            ...state.modalInvite,
            inviteEmail: action.payload.value,
        },
    }),
    [SET_INVITE_ROLE]: (state, action) => ({
        ...state,
        modalInvite: {
            ...state.modalInvite,
            inviteRole: action.payload.value,
        },
    }),
    [EDIT_TEAM_CLASSIFICATIONS_REQUEST_CALLED]: state => ({
        ...state,
        team: {
            ...state.team,
            members: {
                ...state.team.members,
                loadState: LOAD_STATE.LOADING,
            },
        },
    }),
    [EDIT_TEAM_CLASSIFICATIONS_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        team: {
            ...state.team,
            members: {
                loadState: LOAD_STATE.SUCCESS,
                data: state.team.members.data.map((member) => {
                    if (member.membership_id === action.payload.data.membership_id) {
                        return {
                            ...member,
                            internal_teams: action.payload.data.internal_teams,
                        };
                    }
                    return member;
                }),
                error: null,
            },
        },
    }),
    [EDIT_TEAM_CLASSIFICATIONS_REQUEST_FAILED]: (state, action) => ({
        ...state,
        team: {
            ...state.team,
            members: {
                ...state.team.members,
                loadState: LOAD_STATE.FAIL,
                error: action.payload,
            },
        },
    }),
});
